import { COMMON_QUERY_CONFIG, COMMON_QUERY_RULES_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  INVESTOR_CIRCLE = 'Investor Circle'
}

const INVESTOR_CIRCLE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    and: [{ terms: { key: 'Product', value: ['Barrons Investor Circle'] } }],
    not: COMMON_QUERY_RULES_CONFIG.not
  }
};

export { SECTION_ENUM, INVESTOR_CIRCLE };
